<template id="modal">
    <div class="modal-mask" v-if="config.show" :config="config" @click="close">
        <div class="modal-container" @click.stop>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Modal',
        props: {
            config: {
                validator(value) {
                    return value.hasOwnProperty('show') && typeof value.show === 'boolean'
                }
            }  
        },
        methods: {
            close() {
                this.config.show = false
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/Modal/ModalContainer.vue